import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ImageModalActionsBackgroundIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 20 20"
        className="Icon image-modal-actions-background"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth={1.67}
            d="M13.5 17.5H7.443c-.505 0-.758 0-.874-.1a.42.42 0 0 1-.145-.35c.012-.153.19-.331.547-.688l5.42-6.252c.33-.33.495-.496.685-.557a.83.83 0 0 1 .515 0c.19.061.355.226.685.556l3.224 3.224m-4 4.167c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092c.273-.535.273-1.235.273-2.635v-.167m-4 4.167H8.167m9.333-4.167v-1.666m-15 0v1.25m0-4.584v-1.25M6.969 2.5h1.364m-4.583.142A1.85 1.85 0 0 0 2.642 3.75m0 12.5c.196.524.584.912 1.108 1.108M17.5 8.333v-1.25M13.031 2.5h-1.364m4.583.142c.524.196.912.584 1.108 1.108M9.167 7.5a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Z"
        />
    </svg>
);
const Memo = memo(ImageModalActionsBackgroundIcon);
export default Memo;
